import * as definitions from 'store/definitions/steps';

export function fetchAll() {
  return {
    type: definitions.FETCH_ALL_STEPS,
  };
}
